import template from './secureOneRosterApiConnection.html';
import controller from './secureOneRosterApiConnection.controller';

let secureOneRosterApiConnectionComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default secureOneRosterApiConnectionComponent;



// WEBPACK FOOTER //
// ./app/components/secureOneRosterApiConnection/secureOneRosterApiConnection.component.js